import React from 'react';
import { List } from 'semantic-ui-react'
import { Link } from 'react-router-dom';

class AppSidebarNavUtilities extends React.Component {
    render() {
        return (
            <List link>
                <List.Item>
                    <List.Content as="a">
                        Account Setup
          </List.Content>
                </List.Item>
                <List.Item active>
                    <List.Content as="a">
                        Alpha
          </List.Content>
                    <List link>
                        <Link to="/login">Login</Link><List.Item as="a">Login</List.Item>
                        <List.Item as="a">Sub</List.Item>
                        <List.Item as="a">Sub</List.Item>
                    </List>
                </List.Item>
                <List.Item>
                    <List.Content as="a">
                        Beta
          </List.Content>
                    <List link>
                        <List.Item as="a">Sub</List.Item>
                        <List.Item as="a">Sub</List.Item>
                        <List.Item as="a">Sub</List.Item>
                    </List>
                </List.Item>
                <List.Item>
                    <List.Content as="a">
                        Verifications
          </List.Content>
                </List.Item>
                <List.Item>
                    <List.Content as="a">
                        Gamma
          </List.Content>
                    <List link>
                        <List.Item as="a">Sub</List.Item>
                        <List.Item as="a">Sub</List.Item>
                        <List.Item as="a">Sub</List.Item>
                    </List>
                </List.Item>
            </List>
        );
    }
}

AppSidebarNavUtilities.displayName = 'AppSidebarNavUtilities';
AppSidebarNavUtilities.propTypes = {};
AppSidebarNavUtilities.defaultProps = {};
export { AppSidebarNavUtilities };



// WEBPACK FOOTER //
// ./src/components/app/sidebar/NavUtilities.js